import { Injectable } from '@angular/core';
import { Observable, Subscriber } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { User } from '../model/user';

@Injectable()
export class AuthService {

  constructor(private http: HttpClient) { }


  /**
   * Change a specific user's password
   * @param {string} currentPassword The current password of the specified user
   * @param {string} newPassword The new password of the specified user
   * @returns {Observable<User>}
   */
  changePassword(currentPassword: string, newPassword: string): Observable<User> {
    return new Observable<User>((subscriber: Subscriber<User>) => {
      const body = {
        oldPassword: currentPassword,
        newPassword: newPassword
      };

      this.http.put(environment.endpoints.clientBaseUrl + environment.endpoints.changePassword, body)
        .subscribe(
          (response: User) => {
            subscriber.next(response);
            subscriber.complete();
          },
          (error: any) => {
            subscriber.error(error);
          }
        );
    });
  }

}
